export default __webpack_public_path__ + "static/media/sketch_international_banner.977a84c9.jpg";